<template>
  <div id="container">
    <LoggedOutSidebar />
    <div class="view">
      <router-view />
    </div>
  </div>
</template>

<script>
import LoggedOutSidebar from '@/components/LoggedOutSidebar'

export default {
  name: 'LoggedOut',
  components: {
    LoggedOutSidebar
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

.view {
  float: right;
  width: 60%;
  background-color: $light-grey;
}

@media screen and (max-width: 480px) {
  .view {
    width: 100%;
  }
}
</style>
